import he from 'he';
import fp from 'lodash/fp';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const action = createActions({
  CPD_CATEGORYS: {
    GET: undefined,
    API: {
      GET: apiResourceActionCreator('cpdCategorys')
    }
  }
})

export const apiAction = (authToken) => commonApiActions.authenticated.get(API_ENDPOINT, authToken, action.cpdCategorys.api.get)

function* get(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken));
}

const heDecodeCpdCategoryName = (cpdCategorys) => fp.map((aoa) => ({ ...aoa, name: he.decode(aoa.name) }))(cpdCategorys);

const configuration = {
  name: 'get',
  action: action,
  sagas: get,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetching: true
    }),
    success: (state, action) => ({
      ...state,
      isFetching: false,
      cpdCategorys: heDecodeCpdCategoryName(action.payload.cpdCategorys),
      error: null
    }),
    failed: (state, action) => ({
      ...state,
      isFetching: false,
      error: action.payload.error
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/areas-of-advice/configurations/get.js